

export class EmployeeHireLeaveDto implements IEmployeeHireLeaveDto {
    empName!: string | undefined;
    empCode!: number;
    isJoin!: boolean;
    isLeave!: boolean;
    branchId!: number | undefined;
    branchName!: string | undefined;
    joinDate!: Date | undefined;
    resignDate!: Date | undefined;
    remark!: string | undefined;
    finalSalary!: number | undefined;
    companyName!: string | undefined;
    currentSalary!: number | undefined;
    agreement!: string | undefined;
    skills!: string | undefined;

    constructor(data?: IEmployeeHireLeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.empName = _data["empName"];
            this.empCode = _data["empCode"];
            this.isJoin = _data["isJoin"];
            this.isLeave = _data["isLeave"];
            this.branchId = _data["branchId"];
            this.branchName = _data["branchName"];
            this.joinDate = _data["joinDate"] ? new Date(_data["joinDate"].toString()) : <any>undefined;
            this.resignDate = _data["resignDate"] ? new Date(_data["resignDate"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.finalSalary = _data["finalSalary"];
            this.companyName = _data["companyName"];
            this.currentSalary = _data["currentSalary"];
            this.agreement = _data["agreement"];
            this.skills = _data["skills"];
        }
    }

    static fromJS(data: any): EmployeeHireLeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeHireLeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["empName"] = this.empName;
        data["empCode"] = this.empCode;
        data["isJoin"] = this.isJoin;
        data["isLeave"] = this.isLeave;
        data["branchId"] = this.branchId;
        data["branchName"] = this.branchName;
        data["joinDate"] = this.joinDate ? this.joinDate.toISOString() : <any>undefined;
        data["resignDate"] = this.resignDate ? this.resignDate.toISOString() : <any>undefined;
        data["remark"] = this.remark;
        data["finalSalary"] = this.finalSalary;
        data["companyName"] = this.companyName;
        data["currentSalary"] = this.currentSalary;
        data["agreement"] = this.agreement;
        data["skills"] = this.skills;
        return data; 
    }
}

export interface IEmployeeHireLeaveDto {
    empName: string | undefined;
    empCode: number;
    isJoin: boolean;
    isLeave: boolean;
    branchId: number | undefined;
    branchName: string | undefined;
    joinDate: Date | undefined;
    resignDate: Date | undefined;
    remark: string | undefined;
    finalSalary: number | undefined;
    companyName: string | undefined;
    currentSalary: number | undefined;
    agreement: string | undefined;
    skills: string | undefined;
}

